'use client';

import Zzimlogo5024 from '@svg/main/zzimlogo_50_24.svg';
import Hamburger3232 from '@svg/main/hamburger_32_32.svg';
import Link from 'next/link';
import { useSetAtom } from 'jotai';
import { sideMenuModalAtom } from '@/atom/modal';
import { historyStackAtom } from '@/atom/historyStack';
import { usePathname } from 'next/navigation';
import { history } from '@/utils/history';

export default function MainTopBar() {
  const pathname = usePathname();

  const setSideMenuModal = useSetAtom(sideMenuModalAtom);
  const setHistoryStack = useSetAtom(historyStackAtom);

  const onClickSideMenu = () => {
    history?.push(pathname);
    setHistoryStack((prev) => [
      ...prev,
      {
        name: '사이드메뉴 닫기 (from main-top-bar.tsx)',
        afterAction: () => {
          setSideMenuModal(false);
        },
      },
    ]);
    setSideMenuModal(true);
  };

  return (
    <div
      id='main-top-bar'
      className='max-w-480pxr fixed top-0 z-20 flex items-center justify-between w-full overflow-hidden bg-white h-56pxr py-16pxr px-20pxr'
    >
      <Link href={process.env.NEXT_PUBLIC_ZZIMCAR_URL ?? ''} prefetch={false}>
        <Zzimlogo5024 />
      </Link>
      <button onClick={onClickSideMenu} className='w-32pxr h-32pxr'>
        <Hamburger3232 />
      </button>
    </div>
  );
}
